module.exports = __webpack_public_path__ + "static/media/vector-left.ff3618c7.svg";